export default class CognitoException extends Error {
  constructor(code, message) {
    super(message);
    this.name = code;
  }
}
